<template>
    <card-sections :title="Lang.get('employerdashboard::pages/settings/index.title')"
                  :subtitle="Lang.get('employerdashboard::pages/settings/index.subtitle')" :tabName="'general'" :hideMsg="true">

        <p class="font-poppins font-weight-light color-dark-blue">
            {{ Lang.get('employerdashboard::pages/settings/index.general.title') }}</p>
        <div class="form-row mt-3">
            <div class="form-group col-md-6 col-lg-4">
                <text-input :value="company.title" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.company')"></text-input>
            </div>
            <div class="form-group col-md-6 col-lg-4">
                <text-input :value="company.company_registration_number" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.company_registration_number')"></text-input>
            </div>
        </div>
        <div class="form-row mt-3">
            <div class="form-group col-md-6 col-lg-4">
                <text-input :value="company.street" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.address')"></text-input>
            </div>
            <div class="form-group col-md-3">
                <text-input :value="company.housenumber" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.house_number')"></text-input>
            </div>
            <div class="form-group col-md-3">
                <text-input :value="company.housenumber_addition" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.house_number_addition')"></text-input>
            </div>
        </div>
        <div class="form-row mt-3">
            <div class="form-group col-md-6 col-lg-4">
                <text-input :value="company.phonenumber" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.phone')"></text-input>
            </div>
            <div class="form-group col-md-3">
                <text-input :value="company.zipcode" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.zipcode')"></text-input>
            </div>
            <div class="form-group col-md-3">
                <text-input :value="company.city" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.city')"></text-input>
            </div>
        </div>
        <div class="form-row mt-3">
            <div class="form-group col-12 col-md-6 col-lg-4">
                <text-input v-model="company.billing_email" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.billing_email')"></text-input>
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <text-input v-model="company.cost_center" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.cost_center')"></text-input>
            </div>
        </div>
        <div class="form-row mt-3">
            <div class="form-group col-12 col-md-6 col-lg-4">
                <text-input v-model="company.payroll_tax_number" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.payroll_tax_number')"></text-input>
            </div>
            <div class="form-group col-12 col-md-4">
                <text-input v-model="company.iban" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.iban')"></text-input>
            </div>
            <div class="form-group col-12 col-md-4">
                <text-input v-model="company.bic" disabled="disabled"
                            :label="Lang.get('employerdashboard::shared.bic')"></text-input>
            </div>
        </div>
        <div class="form-row mt-4" v-if="allowed_to_edit_details">
            <div class="form-group col-12 col-md-4 col-lg-3">
                <inertia-link
                    :href="route('nl.employerdashboard.settings.edit', this.$page.props.auth.user.selected_company.uuid)"
                    class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                    {{ Lang.get('employerdashboard::shared.edit') }}
                </inertia-link>
            </div>
        </div>

    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/settings/index.title'),
        }
    },
    components: {
        CardSections,
        TextInput,
    },
    props: {
        errors: Object,
        company: Object,
        allowed_to_edit_details: Boolean,
    },
    methods: {
        url() {
            return location.href;
        },
    }
}
</script>
